import { t } from "i18next";

import {
  FormSectionSchema,
  IncidentFormTypeSchema,
  WorkflowVersionSchema,
  type AnyWorkflow,
} from "../../types/index.js";
import { tk } from "../../types/Translation.js";
import { detentionDetailsFormBuilder } from "../workflow_BTP_1_0/detentionDetails.js";
import { informationForHealthcareFormBuilder } from "../workflow_BTP_1_0/informationForHealthcare.js";
import { formSpecification as personDetailsFormSpecification } from "../workflow_BTP_1_0/personDetails.js";
import { workflow_BTP_1_1 } from "../workflow_BTP_1_1/workflow.js";

const detentionDetailsFormSpecification = detentionDetailsFormBuilder()
  .withFormValidation(({ formValues, t }) =>
    formValues.incidentAndLocationSameLocation === null
      ? [
          {
            fieldName: "incidentAndLocationSameLocation",
            message: t(
              "detentionDetails.originalPoliceIncidentSameLocationRequired",
            ),
          },
        ]
      : [],
  )
  .build({ t });

const informationForHealthcareFormSpecification =
  informationForHealthcareFormBuilder()
    .withFormValidation(({ formValues, t }) =>
      formValues.wasForceUsed?.value === "yes" &&
      (formValues.useOfForceType === null ||
        formValues.useOfForceType.length === 0)
        ? [
            {
              fieldName: "useOfForceType",
              message: t("informationForHealthcare.useOfForceType.required"),
            },
          ]
        : [],
    )
    .build({ t });

/**
 * Two section 136 questions decide whether the questions beneath them are
 * asked: whether the incident and the detention happened in the same place, and
 * which use-of-force tactics were used. This version requires an answer to the
 * first, and to the second wherever force was used.
 *
 * Earlier versions keep both optional because records made before the questions
 * existed cannot answer them. The requirement is a form rule rather than a
 * tightened field schema so that the stored shape is the same in every version.
 * An incident keeps the version it was created under, so those records are
 * unaffected.
 */
export const workflow_BTP_1_2 = {
  ...workflow_BTP_1_1,
  workflowVersion: WorkflowVersionSchema.enum.BTP_1_2,
  [IncidentFormTypeSchema.enum.section136]: {
    formDefinition: {
      sections: [
        {
          id: FormSectionSchema.enum.personDetails,
          name: tk("incidentFormSections.person"),
          autoSave: true,
          buildFormSpecification: personDetailsFormSpecification,
        },
        {
          id: FormSectionSchema.enum.detentionDetails,
          name: tk("incidentFormSections.detention"),
          autoSave: true,
          buildFormSpecification: detentionDetailsFormSpecification,
        },
        {
          id: FormSectionSchema.enum.informationForHealthcare,
          name: tk("incidentFormSections.information"),
          autoSave: true,
          buildFormSpecification: informationForHealthcareFormSpecification,
        },
      ],
    },
  },
} satisfies AnyWorkflow;
